module.exports = __webpack_public_path__ + "images/logos/west-coast-self-storage.svg";